module.exports = __webpack_public_path__ + "files/16d098f3646d281eb2f3afdbe173ef9f.png";